import type { ReactNode } from 'react';
import { Header } from '../Header';

interface MainLayoutProps {
  children: ReactNode;
}

export function MainLayout({ children }: MainLayoutProps) {
  return (
    <div className="h-full w-full flex flex-col">
      <Header />
      <main className="h-[calc(100%-4.3em)] relative overflow-hidden">{children}</main>
    </div>
  );
}
